import { ICustomSectionTemplateResponse } from 'services/templates/section-template/types';
import {
  IContractTemplateTreeItemForm,
  TEMPLATE_TYPE,
} from 'services/templates/types';
import { contractTemplateUtil } from 'utils';
import { connectTemplateTreeItems } from '../templateQueryItemsConnector';

export const sectionTemplateQueryToForm = (
  section: ICustomSectionTemplateResponse,
  lowestAvailableId?: string
): IContractTemplateTreeItemForm[] => {
  return contractTemplateUtil.section.initialValues([
    {
      id: lowestAvailableId ?? '1',
      content: section.title,
      type: TEMPLATE_TYPE.section,
      children: connectTemplateTreeItems(
        {
          agreements: section.agreements,
          customSections: section.customSections,
        },
        lowestAvailableId ?? '2'
      ),
    },
  ]);
};
